import { useState, useEffect } from 'react';

export default function useOnScreen(ref) {
	const [isIntersecting, setIntersecting] = useState(false);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => entry.isIntersecting && !isIntersecting && setIntersecting(entry.isIntersecting),
		);

		observer.observe(ref.current);
		// Remove the observer as soon as the component is unmounted
		return () => {
			observer.disconnect();
		};
	}, []);

	return isIntersecting;
}
